import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./store";
import "vue-trix";

Vue.config.productionTip = true;
Vue.config.ignoredElements = ['trix-editor'];

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
